const SAME_NATURE_LIST = [
  {
    key: '01',
    text: '01 - Fonctionnement',
    value: '01',
  },
  {
    key: '02',
    text: '02 - Investissement',
    value: '02',
  },
  {
    key: '03',
    text: '03 - Inventaire',
    value: '03',
  },
  {
    key: '04',
    text: '04 - Emprunt',
    value: '04',
  },
  {
    key: '05',
    text: '05 - Régie',
    value: '05',
  },
  {
    key: '06',
    text: '06 - Annulation-Réduction',
    value: '06',
  },
  {
    key: '07',
    text: '07 - Complémentaire',
    value: '07',
  },
  {
    key: '08',
    text: '08 - Reémis',
    value: '08',
  },
] as const;

const NATURE_PIECE = {
  DEPENSE: {
    FONCTIONNEMENT: '01',
    INVESTISSEMENT: '02',
    INVENTAIRE: '03',
    EMPRUNT: '04',
    REGIE: '05',
    ANNUL_REDUC: '06',
    COMPLEMENTAIRE: '07',
    REEMIS: '08',
    ANNUL_TITRE: '09',
    ANNUL_MANDAT_RATT: '10',
    PAIE: '11',
    RETENUE_GARANTIE: '12',
    DERNIER_ACOMPTE_MARCHE: '13',
    AVANCE_FORFAIT: '14',
    OPE_ORDRE_LIEE_CESSIONS: '18',
  },
  DEPENSE_LIST: [
    ...SAME_NATURE_LIST,
    {
      key: '09',
      text: '09 - Annulant un titre',
      value: '09',
    },
    {
      key: '10',
      text: '10 - Annulation du mandat de rattachement',
      value: '10',
    },
    {
      key: '11',
      text: '11 - Paie',
      value: '11',
    },
    {
      key: '12',
      text: '12 - Retenue de garantie',
      value: '12',
    },
    {
      key: '13',
      text: '13 - Dernier acompte sur marché',
      value: '13',
    },
    {
      key: '14',
      text: '14 - Avance forfaitaire',
      value: '14',
    },
    {
      key: '18',
      text: "18 - Opération d'ordre liée aux cessions",
      value: '18',
    },
  ],
  RECETTE: {
    FONCTIONNEMENT: '01',
    INVESTISSEMENT: '02',
    INVENTAIRE: '03',
    EMPRUNT: '04',
    REGIE: '05',
    ANNUL_REDUC: '06',
    COMPLEMENTAIRE: '07',
    REEMIS: '08',
    ANNUL_MANDAT: '09',
    ANNUL_TITRE_RATT: '10',
    MARCHE: '11',
    OPE_ORDRE_LIEE_CESSIONS: '18',
  },
  RECETTE_LIST: [
    ...SAME_NATURE_LIST,
    {
      key: '09',
      text: '09 - Annulant un mandat',
      value: '09',
    },
    {
      key: '10',
      text: '10 - Annulation du titre de rattachement',
      value: '10',
    },
    {
      key: '11',
      text: '11 - Marché',
      value: '11',
    },
    {
      key: '18',
      text: "18 - Opération d'ordre liée aux cessions",
      value: '18',
    },
  ],
} as const;

export default NATURE_PIECE;
